<template>
    <div>
        <v-skeleton-loader v-if="loading" type="table" class="my-4"></v-skeleton-loader>
        <v-simple-table v-else dense>
            <thead>
                <tr>
                    <th width="100px"><b>Date</b></th>
                    <th width="140px"><b>Trans</b></th>
                    <th width="120px"><b>Trans #</b></th>
                    <th><b>Description</b></th>
                    <th><b>Debit</b></th>
                    <th><b>Credit</b></th>
                    <th><b>Balance</b></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td colspan="6"><b>{{ statement.opening_balance.description }}</b></td>
                    <td><b>{{ formatMoney(statement.opening_balance.balance, currency, decimal) }}</b></td>
                </tr>
                <tr v-for="trans in statement.transactions" :key="trans.transaction_id">
                    <td width="130">{{ trans.date }}</td>
                    <td>{{ trans.transaction }}</td>
                    <td>{{ trans.transaction_code }}</td>
                    <td>{{ trans.description }}</td>
                    <td>{{ formatNumber(trans.debit, decimal) }}</td>
                    <td>{{ formatNumber(trans.credit, decimal) }}</td>
                    <td>{{ formatNumber(trans.balance, decimal) }}</td>
                </tr>
                <tr class="secondary">
                    <td colspan="4"><b>{{ statement.ending_balance.description }}</b></td>
                    <td><b>{{ formatNumber(statement.ending_balance.debit) }}</b></td>
                    <td><b>{{ formatNumber(statement.ending_balance.credit) }}</b></td>
                    <td><b>{{ formatMoney(statement.ending_balance.balance, currency, decimal) }}</b></td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import {formatMoney, formatNumber} from 'accounting';

export default {
    name: "CustomerStatementTable",
    props: {
        statement: {
            type: Object
        },
        loading: {
            type: Boolean
        }
    },
    data() {
        return {
            currency: "SDG",
            decimal: 2
        }
    },
    methods: {
        formatMoney,
        formatNumber
    }
}
</script>